import * as CONSTANTS from './constants';

export const getInitialState = () => {
  return {
    src: '',
    dest: '',
    src_vid: '',
    dest_vid: '',
    doj: '',//yyyymmdd
    rDoj: '',
    journeyType: 'onw',
    onwBid: '',
    retBid: '',
    flavour: 'mweb',
    dojObj: null,
    src_name: '',
    dest_name: '',
    redirect: false,
    operator_name: '',
    operator_id: '',
    bus_type: '',
    cityName: '',
    cityDisplayName: '',
    filterStr: '',
    pageNumber: 1,
    pageType: "",
    stand: "",
  };
}

export default function BusCommonSEO(state = getInitialState(), action) {
  const { type, actionData } = action;
  switch (type) {
    case CONSTANTS.JOURNEY_PARAMS:
      return Object.assign({}, state, {
        ...state,
        src: actionData.src,
        dest: actionData.dest,
        src_vid: actionData.src_vid,
        dest_vid: actionData.dest_vid,
        doj: actionData.doj,
        dojObj: actionData.dojObj,
        rDoj: actionData.rDoj,
        journeyType: actionData.journeyType,
        onwBid: actionData.onwBid,
        retBid: actionData.retBid,
        flavour: actionData.flavour,
        src_name: actionData.src_name,
        dest_name: actionData.dest_name,
        redirect: actionData.redirect || state.redirect,
        operator_id: actionData.operator_id || '',
        operator_name: actionData.operator_name || '',
        bus_type: actionData.bus_type || '',
        cityName: actionData.cityName || state.cityName,
        cityDisplayName: actionData.cityDisplayName || state.cityDisplayName,
        filterStr: actionData.filterStr && actionData.filterStr.length ? actionData.filterStr : state.filterStr,
        pageNumber: actionData.pageNumber || 1,
        pageType: actionData.pageType || "",
        stand: actionData.stand || ""
      })
    default:
      return state;
  }
}

